import baseStyles from '../Base/Base.styles'
import merge from 'lodash/merge'
import { parseResponsiveProperty } from '@converdy/styles'
import SwipeableGridStyles from '../SwipeableGrid/SwipeableGrid.styles'

function toRatio(ratioString) {
  let imageRatio = ratioString.split('/')
  return imageRatio[1] / imageRatio[0] * 100
}

export default ({
  base,
  ratio,
  objectFit,
  customHeight,
  horizontalPadding,
  verticalPadding,
  backgroundColor,
  items,
  swipeableGrid
}) => {

  let jss = {
    root: {
      ...baseStyles(base),
      '--horizontal-padding': '0px', 
      '--vertical-padding': '0px', 
      ...merge(
        parseResponsiveProperty((c) => ({
          '--horizontal-padding': `${c}px` 
        }), horizontalPadding),  
        parseResponsiveProperty((c) => ({
          '--vertical-padding': `${c}px` 
        }), verticalPadding),  
      ),
      '& .grid .item img': {
        objectFit
      }
    }
  }

  merge(jss.root, {
    '& .grid-wrapper': SwipeableGridStyles(swipeableGrid)
  })
  
  if(backgroundColor) {
    merge(jss.root, {
      '& .grid .item': {
        backgroundColor: backgroundColor,
      }
    })
  }

  if(ratio !== 'customHeight') {
    merge(jss.root, {'& .grid:not(.converdy-swipable) .item': {
        paddingTop: `${toRatio(ratio)}%`,
      }
    })
  }
  
  if(ratio === 'customHeight') {
    merge(jss.root, {'& .grid .item': {
      ...parseResponsiveProperty(({value, unit}) => ({
        'height': `${value}${unit}` 
      }), customHeight),  
      }
    })
  }

  return jss
}
